import React, { Component } from 'react'
import { Main } from '../../layouts'
import { colors } from '../../styles'
import { CombinedTitle, Button } from '..'
import { P } from '../StyledText'
// TODO: reimplement and carry out to separate component, review all CollapsePanel's @Andrew
import { CollapsePanel } from '../GraphicSidebar/CollapsePanel'
import { getGraphicsURL } from '../../services/config'

export class ErrorBoundary extends Component {
  public state = {
    error: null,
    details: null,
  }

  public componentDidCatch(errorObj, errorInfo) {
    const error = errorObj.toString()
    const details = errorInfo.componentStack
    this.setState({ error, details })
  }

  public render() {
    const { error, details } = this.state
    return error ? (
      <Main
        titleBlock={
          <>
            <br />
            <CombinedTitle
              first="Application"
              second="Error"
              color={colors.error}
            />
          </>
        }
      >
        <br />
        <P>
          Something went wrong. The application has crashed with the following
          message:
        </P>
        <br />
        <CollapsePanel summary={<P color="error">{error}</P>}>
          <P color="error">{details}</P>
        </CollapsePanel>
        <br />
        <a href={encodeURI(getGraphicsURL())} style={{ all: 'unset' }}>
          <Button id="home-page" color="secondary" variant="contained">
            Reload the application
          </Button>
        </a>
      </Main>
    ) : (
      this.props.children
    )
  }
}
